import { forwardRef } from "react";
import styled from "styled-components/macro";

import { darkGradient, lightGradient, shimmer } from "./CardSkeleton";

const Picture = forwardRef(({ children, theme, ...rest }, ref) => (
  <StyledPicture {...rest} ref={ref}>
    {rest["data-status"] === "loading" && <LoadingImage theme={theme} />}
    {children}
  </StyledPicture>
));

export default Picture;

const StyledPicture = styled.picture`
  position: relative;

  &[data-status="error"],
  &[data-status="loading"] {
    background-position: center center;
    background-repeat: no-repeat;
    overflow: hidden;
    text-indent: 100%;
    white-space: nowrap;
  }

  &[data-status="error"] {
    background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20260%20260%22%3E%3Cpath%20d%3D%22M255.1%20211.8c8.2%2014.2-2.1%2032-18.5%2032H23.4c-16.4%200-26.7-17.8-18.5-32L111.5%2026.9c8.2-14.2%2028.8-14.2%2037%200l106.6%20184.9zM130%20173.6c-11.3%200-20.4%209.2-20.4%2020.4s9.2%2020.4%2020.4%2020.4%2020.4-9.2%2020.4-20.4-9.1-20.4-20.4-20.4zm-19.4-73.5l3.3%2060.4c.2%202.8%202.5%205%205.3%205h21.6c2.8%200%205.2-2.2%205.3-5l3.3-60.4c.2-3.1-2.3-5.6-5.3-5.6h-28.2c-3-.1-5.5%202.5-5.3%205.6z%22%20fill%3D%22%23999%22%2F%3E%3C%2Fsvg%3E");
    background-size: 30%;
    opacity: 0.3 !important;

    img {
      opacity: 0 !important;
    }
  }
`;

const LoadingImage = styled.div`
  background-color: ${({ theme }) =>
    theme === "dark" ? "#3d3d3d" : "#dfdfdf"};
  height: 100%;
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 1;

  &:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    ${({ theme }) => (theme === "dark" ? darkGradient : lightGradient)}
    animation: ${shimmer} 2s ease-in-out infinite;
    content: "";
  }
`;
